import { render, staticRenderFns } from "./ModalHistoricoPermissoes.vue?vue&type=template&id=481375d8"
import script from "./ModalHistoricoPermissoes.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoPermissoes.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoPermissoes.vue?vue&type=style&index=0&id=481375d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports